import React from "react";
import { Check } from "react-feather";
import { Card } from "../../../../shared/Card/Card";
import { Metric } from "./types";
import "./tabs.scss";

interface PerformanceMetricsGridProps {
  metrics: Metric[];
  selectedMetric: string | null;
  onMetricSelect: (metricId: string) => void;
}

const PerformanceMetricsGrid: React.FC<PerformanceMetricsGridProps> = ({
  metrics,
  selectedMetric,
  onMetricSelect,
}) => {
  return (
    <Card>
      <div className="performance-metrics-grid">
        {metrics.map((metric) => (
          <div
            key={metric.id}
            className={`metric-card ${metric.color} ${
              selectedMetric === metric.id ? "selected" : ""
            }`}
            onClick={() => onMetricSelect(metric.id)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                onMetricSelect(metric.id);
              }
            }}
          >
            <div className="metric-icon">
              <Check size={16} />
            </div>
            <div className="metric-score">
              {metric.score}/{metric.maxScore}
            </div>
            <div className="metric-name">{metric.name}</div>
          </div>
        ))}
      </div>
      <div className="click-hint">Click Category for More Details</div>
    </Card>
  );
};

export default PerformanceMetricsGrid;

